"use client";

import { c as _c } from "react/compiler-runtime";
import React, { createContext, useContext } from "react";
interface ModalContext {
  close: () => void;
}
const ModalContext = createContext<ModalContext | null>(null);
interface ModalProviderProps {
  children?: React.ReactNode;
  close: () => void;
}
export const ModalProvider = t0 => {
  const $ = _c(5);
  const {
    children,
    close
  } = t0;
  let t1;
  if ($[0] !== close) {
    t1 = {
      close
    };
    $[0] = close;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <ModalContext.Provider value={t1}>{children}</ModalContext.Provider>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export const useModal = () => {
  const context = useContext(ModalContext);
  if (context === null) {
    throw new Error("useModal must be used within a ModalProvider");
  }
  return context;
};